export const profileConstants = {
  GET_PROFILE_REQUEST: 'PROFILE_GET_DETAILS_REQUEST',
  GET_PROFILE_SUCCESS: 'PROFILE_GET_DETAILS_SUCCESS',
  GET_PROFILE_FAILURE: 'PROFILE_GET_DETAILS_FAILURE',
};
